export function initMetaPirschEvents() {
  function bindPirschClickEvents() {
    if (typeof pirsch !== 'function') return;

    document.querySelectorAll('[data-pirsch-event]').forEach((el) => {
      if (el.dataset.pirschBound === 'true') return;
      el.dataset.pirschBound = 'true';

      const fire = () => {
        const name = el.getAttribute('data-pirsch-event');
        if (!name) return;

        const meta = {};
        for (const attr of el.attributes) {
          if (attr.name.startsWith('data-pirsch-meta-')) {
            meta[attr.name.slice('data-pirsch-meta-'.length)] = attr.value;
          }
        }

        pirsch(name, Object.keys(meta).length ? { meta } : undefined);
      };

      el.addEventListener('click', fire);
      el.addEventListener('auxclick', fire);
    });
  }

  document.addEventListener('pirsch:ready', bindPirschClickEvents);

  if (typeof pirsch === 'function') {
    bindPirschClickEvents();
  }
}
